import { render, staticRenderFns } from "./EcClass.vue?vue&type=template&id=5f1785a2&scoped=true"
import script from "./EcClass.vue?vue&type=script&lang=js"
export * from "./EcClass.vue?vue&type=script&lang=js"
import style0 from "./EcClass.vue?vue&type=style&index=0&id=5f1785a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1785a2",
  null
  
)

export default component.exports